import { Injectable, inject } from '@angular/core';
import {TaskColor} from "../../models/task-color.model";
import {SessionService} from "@core";
import {SessionColors} from "../../models/session-color.model";

@Injectable({
    providedIn: 'root'
})
export class TaskColorService {
    private readonly sessionService = inject(SessionService);

    private storageKey = "sessionTasksColors";
    private sessionColors: SessionColors;

    constructor() {
        this.initSessionCheck();
    }

    public addColorToTask(newColor: string, taskId: string) {
        const task = this.sessionColors.tasksColors.find(taskColor => taskColor.taskId === taskId);

        if (task) {
            task.color = newColor;
        } else {
            this.sessionColors.requestId = this.sessionService.requestId;
            this.sessionColors.tasksColors.push({ taskId, color: newColor} as TaskColor);
        }
        this.saveTaskColorData();
    }

    public getTaskColors(): TaskColor[] {
        return this.sessionColors.tasksColors;
    }

    private initSessionCheck() {
        const savedSessionColors = this.getAllSessionColors();
        this.initTaskColorCollection();
        if (this.sessionService.requestId === savedSessionColors.requestId) {
            this.sessionColors.tasksColors = savedSessionColors.tasksColors;
        } else {
            this.sessionColors.requestId = this.sessionService.requestId;
            this.saveTaskColorData();
        }
    }

    private getAllSessionColors(): SessionColors {
        const data = sessionStorage.getItem(this.storageKey);
        return data ? JSON.parse(data) : { requestId: '', tasksColors: [] };
    }

    private initTaskColorCollection() {
        this.sessionColors = {} as SessionColors;
        this.sessionColors.tasksColors = [] as TaskColor[];
        this.sessionColors.requestId = this.sessionService.requestId;
    }

    private saveTaskColorData() {
        sessionStorage.setItem("sessionTasksColors", JSON.stringify(this.sessionColors));
    }
}
